import { Grid } from '../../../../../app/core/components/grid/grid.model';

(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('shopFloor', {
        templateUrl: 'views/components/views/shopFloor/shopFloor.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: [
            '$stateParams',
            'stateService',
            'utilityService',
            'translateService',
            'modalService',
            'shopFloorService',
            'logisticService',
            'labourPositionService',
            'operationFactoryService',
            'ttGridFactory',
            'rememberService',
            'tsModalService',
            function ($stateParams, stateService, utilityService, translateService, modalService, shopFloorService, logisticService, labourPositionService, operationFactoryService, ttGridFactory, rememberService, tsModalService) {
                // #region VARIABLES & DEFINITIONS

                const vm = this;

                let argType = $stateParams.argtype;
                let argValue = $stateParams.argvalue;
                let compIsProdId = $stateParams.comp_is_prod_id;

                let variableNames = {
                    businessco_no: '',
                    factory_id: '',
                    operation_id: '',
                    equipment_id: '',
                    labour_no: '',
                    selected_jobid: '',
                    selected_jobtype: '',
                    date_fom: '',
                    date_tom: '',
                    dateselector_index: '',
                    gb_shopfloor_main: '',
                };

                let translations = {
                    error: '',
                    ok: '',
                };

                vm.model = {
                    gridReady: false,
                    gridOrdersReady: false,

                    operationButtons: [{ id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.onChanged('', 'operation_id') }],
                    equipmentButtons: [{ id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('equipment_id') }],
                    bgShopFloor: {
                        selected: 'POW',
                        buttons: [
                            { id: 'POW', label: 'gb_shopfloor_main_pow', color: 'primary', onClick: () => setShopFloorView('POW') },
                            { id: 'ORDERS', label: 'gb_shopfloor_main_orders', color: 'primary', onClick: () => setShopFloorView('ORDERS') },
                        ],
                    },
                    setting: {},
                    selectListCompanies: [],
                    selectListFactories: [],
                    selectListOperations: [],
                    selectListEquipments: [],
                    selectListLabours: [],
                    startingJob: false,
                };

                //vm.style = {
                //    basic: {},
                //    container: {
                //    },
                //    img: {
                //        minHeight: `25px`
                //    },
                //    placeholder: {
                //        minHeight: `25px`
                //    }
                //};

                vm.grid = new ttGridFactory({
                    rememberId: 'w_shopfloor_grid',
                    kendo: {
                        height: '100%',
                        sortable: true,
                        aggregate: true,
                        pager: false,
                        selectable: false,
                        filterable: false,
                    },
                }).setOptionFunc((data) => optionFunc(data.data));

                function optionFunc(data) {
                    if (data?.func && data.func === 'CellClickHandler') {
                        vm.model.setting.selected_jobid = data.clickedCell.dataItem.pow_keyno;
                        vm.model.setting.selected_jobtype = 'pow_keyno';

                        if (vm.model.setting.selected_jobid === data.clickedCell.dataItem.pow_keyno) {
                            Promise.all([rememberFunc('selected_jobid'), rememberFunc('selected_jobtype')]).then(() => {
                                retrieveSelectedJob();
                                Promise.resolve();
                            });
                        }
                    }
                }

                vm.gridOrders = new Grid()
                    .setRememberId('w_shopfloor_orders_grid')
                    .setLoadDataFunction({ method: 3699, parameters: () => vm.model.setting })
                    .addRowButton({
                        name: 'orderpicknew',
                        tooltip: 'orderpicknew',
                        translateTooltip: true,
                        icon: 'far fa-plus',
                        btn_type: 'primary',
                        func: async (row) => {
                            const response = await tsModalService.openStateDialog({ state: 'orderpicknew', params: `order_internal_no/${row['order_internal_no']}` });

                            if (!!response) vm.gridOrders.gridfunc?.read();
                        },
                    })
                    .setOptionFunc((data) => optionFuncOrders(data.data));

                // vm.gridOrders = new ttGridFactory({
                //     rememberId: 'w_shopfloor_orders_grid',
                //     kendo: {
                //         height: '100%',
                //         sortable: true,
                //         aggregate: true,
                //         pager: false,
                //         selectable: false,
                //         filterable: false,
                //     },
                // }).setOptionFunc((data) => optionFuncOrders(data.data));

                function optionFuncOrders(data) {
                    if (data?.func && data.func === 'CellClickHandler') {
                        vm.model.setting.selected_jobid = data.clickedCell.dataItem.order_internal_no;
                        vm.model.setting.selected_jobtype = 'order_internal_no';

                        if (vm.model.setting.selected_jobid === data.clickedCell.dataItem.order_internal_no) {
                            Promise.all([rememberFunc('selected_jobid'), rememberFunc('selected_jobtype')]).then(() => {
                                retrieveSelectedJob();
                                Promise.resolve();
                            });
                        }
                    }
                }

                // #endregion VARIABLES & DEFINITIONS

                // #region TRANSLATE SERVICE

                async function translate() {
                    let data = await translateService.translateBatch(translations);

                    Object.keys(translations).forEach((key) => {
                        if (data?.[key]) translations[key] = data[key];
                    });
                }

                // #endregion TRANSLATE SERVICE

                // #region BUTTON RADIO FUNCTIONS

                function setShopFloorView(id) {
                    vm.model.bgShopFloor.selected = vm.model.setting.gb_shopfloor_main = id;
                }

                // #endregion BUTTON RADIO FUNCTIONS

                // #region LOAD PROCEDURE FUNCTION CALLS

                async function loadSetting() {
                    vm.model.setting = (
                        await shopFloorService.getSetting({
                            argtype: argType,
                            argvalue: argValue,
                            comp_is_prod_id: compIsProdId,
                        })
                    )[0];

                    setShopFloorView(vm.model.setting.gb_shopfloor_main);

                    Promise.all([loadFactories(), loadOperations(), loadSelectEquipments(), loadLabours(), retrieveSelectedJob()]).then(() => {
                        loadGrid();
                        loadGridOrders();
                        Promise.resolve();
                    });
                }

                async function loadCompanies() {
                    vm.model.selectListCompanies = await logisticService.listCompanies();
                }

                async function loadFactories() {
                    if (utilityService.validateParmsValue(vm.model.setting.businessco_no, true) !== true) return;

                    vm.model.selectListFactories = await labourPositionService.listSelectFactories({ businessco_no: vm.model.setting.businessco_no });
                }

                async function loadLabours() {
                    if (utilityService.validateParmsValue(vm.model.setting.businessco_no, true) !== true) return;

                    vm.model.selectListLabours = await shopFloorService.listLabours({ businessco_no: vm.model.setting.businessco_no });
                }

                async function loadOperations() {
                    if (utilityService.validateParmsValue(vm.model.setting.factory_id, true) !== true) return;

                    vm.model.selectListOperations = await logisticService.listOperations({
                        direct: '1',
                        factory_id: vm.model.setting.factory_id,
                    });
                }

                async function loadSelectEquipments() {
                    if (utilityService.validateParmsValue(vm.model.setting.factory_id, true) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.setting.operation_id, true) !== true) return;

                    vm.model.selectListEquipments = await operationFactoryService.listSelectEquipments({
                        workgrp_keyno: '0',
                        factory_id: vm.model.setting.factory_id,
                        operation_id: vm.model.setting.operation_id,
                    });
                }

                async function retrieveSelectedJob() {
                    if (utilityService.validateParmsValue(vm.model.setting.businessco_no, true) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.setting.factory_id, true) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.setting.operation_id, true) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.setting.equipment_id, true) !== true) return;
                    if (utilityService.validateParmsValue(vm.model.setting.labour_no, true) !== true) return;

                    return shopFloorService.getSelectedJob(vm.model.setting).then((response) => {
                        vm.model.setting.prod_id = response[0].prod_id;
                        vm.model.setting.prod_name = response[0].prod_name;
                        vm.model.setting.url_picture = response[0].url_picture;
                        vm.model.setting.show_button_start_selected_job = response[0].show_button_start_selected_job;
                        vm.model.setting.stamped = response[0].stamped;
                        vm.model.setting.order_order_no = response[0].order_order_no;
                        vm.model.setting.stat_cust_name = response[0].stat_cust_name;
                    });
                }

                // #endregion LOAD PROCEDURE FUNCTION CALLS

                // #region GRID PROCEDURE FUNCTION CALLS

                async function loadGrid() {
                    vm.grid.dataTask.loadData = {
                        method: 3681,
                        parameters: vm.model.setting,
                    };

                    vm.model.gridReady = true;

                    if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
                }

                async function loadGridOrders() {
                    // vm.gridOrders.dataTask.loadData = {
                    //     method: 3699,
                    //     parameters: vm.model.setting,
                    // };

                    vm.model.gridOrdersReady = true;

                    if (vm.gridOrders.gridfunc !== null) vm.gridOrders.gridfunc.read();
                }

                // #endregion GRID PROCEDURE FUNCTION CALLS

                // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

                function rememberFunc(id) {
                    Object.keys(variableNames).forEach((key) => {
                        variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                    });

                    if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                    let variableValue = null;

                    switch (id) {
                        case 'businessco_no':
                        case 'factory_id':
                        case 'operation_id':
                        case 'equipment_id':
                        case 'labour_no':
                        case 'selected_jobid':
                        case 'selected_jobtype':
                            if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

                            variableValue = vm.model.setting[id];
                            break;
                        case 'date_fom':
                        case 'date_tom':
                        case 'dateselector_index':
                        case 'gb_shopfloor_main':
                            if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

                            variableValue = vm.model.setting[id];
                            break;
                        default:
                            break;
                    }

                    return rememberService.remember(variableNames[id], variableValue);
                }

                // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

                // #region RESET BUTTON FUNCTION

                function reset(id) {
                    switch (id) {
                        case 'equipment_id':
                            vm.model.setting.equipment_id = '';

                            if (vm.model.setting.equipment_id === '') {
                                Promise.all([rememberFunc('equipment_id')]).then(() => {
                                    loadGrid();
                                    loadGridOrders();
                                    Promise.resolve();
                                });
                            }
                            break;
                        default:
                            break;
                    }
                }

                // #endregion RESET BUTTON FUNCTION

                // #region BUTTON SAVE PROCEDURE FUNCTION CALL

                vm.startJob = function () {
                    vm.model.startingJob = true;

                    shopFloorService.startSelectedJob(vm.model.setting).then((response) => {
                        if (response[0] && response[0].errorcode !== '0') {
                            modalService.show({
                                type: 'warning',
                                title: translations.error,
                                message: response[0].errormessage,
                                buttons: [
                                    {
                                        label: translations.ok,
                                        cssClass: 'btn-warning',
                                        action: function (dialogItself) {
                                            dialogItself.close();
                                            vm.model.startingJob = false;
                                        },
                                    },
                                ],
                            });
                        } else {
                            vm.model.startingJob = false;

                            retrieveSelectedJob();

                            if (response[0].goto_item_state > '') stateService.go(response[0].goto_item_state, response[0].goto_item_parms);
                        }
                    });
                };

                // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

                // #region BUTTON RADIO FUNCTIONS

                vm.selectBgShopFloor = function (value) {
                    vm.model.bgShopFloor.selected = value;
                    vm.model.setting.gb_shopfloor_main = vm.model.bgShopFloor.selected;

                    rememberFunc('gb_shopfloor_main');
                };

                // #endregion BUTTON RADIO FUNCTIONS

                // #region MULTI DIRECTION BUTTON FUNCTIONS

                vm.goToFunc = function (state, e) {
                    function go(parms) {
                        if (e?.ctrlKey) {
                            stateService.newTab(state, parms);
                        } else {
                            stateService.go(state, parms);
                        }
                    }

                    switch (state) {
                        case 'picturebanks':
                            go({
                                argtype: 'prod_id',
                                argvalue: vm.model.setting.prod_id,
                            });
                            break;
                        case 'trnewjobconf':
                            go({
                                labour_no: vm.model.setting.labour_no,
                                argtype: 'exit',
                                argvalue: '0',
                            });
                            break;
                        default:
                            break;
                    }
                };

                // #endregion MULTI DIRECTION BUTTON FUNCTIONS

                // #region ON BLUR MULTI FUNCTIONS

                vm.onBlur = function (id) {
                    switch (id) {
                        case 'labour_no':
                            if (utilityService.validateParmsValue(vm.model.setting.labour_no, true) !== true) return;

                            Promise.all([rememberFunc('labour_no'), retrieveSelectedJob()]).then(() => {
                                loadGrid();
                                loadGridOrders();
                                Promise.resolve();
                            });
                            break;
                            break;
                        default:
                            break;
                    }
                };

                // #endregion ON BLUR MULTI FUNCTIONS

                // #region FIELD CHANGE MULTI FUNCTIONS

                vm.onChanged = function (value, id) {
                    switch (id) {
                        case 'businessco_no':
                            if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

                            vm.model.setting.businessco_no = value;

                            if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

                            Promise.all([rememberFunc('businessco_no'), loadFactories(), loadLabours()]).then(() => {
                                loadGrid();
                                loadGridOrders();
                                Promise.resolve();
                            });
                            break;
                        case 'factory_id':
                            if (utilityService.validateWatchValue(value, vm.model.setting.factory_id) !== true) return;

                            vm.model.setting.factory_id = value;

                            if (utilityService.validateParmsValue(vm.model.setting.factory_id, true) !== true) return;

                            Promise.all([rememberFunc('factory_id'), loadOperations(), loadSelectEquipments()]).then(() => {
                                loadGrid();
                                loadGridOrders();
                                Promise.resolve();
                            });
                            break;
                        case 'operation_id':
                            if (utilityService.validateWatchValue(value, vm.model.setting.operation_id) !== true) return;

                            vm.model.setting.operation_id = value;

                            if (utilityService.validateParmsValue(vm.model.setting.operation_id, true) !== true) return;

                            Promise.all([rememberFunc('operation_id'), loadSelectEquipments()]).then(() => {
                                loadGrid();
                                loadGridOrders();
                                Promise.resolve();
                            });
                            break;
                        case 'equipment_id':
                            if (utilityService.validateWatchValue(value, vm.model.setting.equipment_id) !== true) return;

                            vm.model.setting.equipment_id = value;

                            if (utilityService.validateParmsValue(vm.model.setting.equipment_id, true) !== true) return;

                            Promise.all([rememberFunc('equipment_id')]).then(() => {
                                loadGrid();
                                loadGridOrders();
                                Promise.resolve();
                            });
                            break;
                        case 'labour_no':
                            if (utilityService.validateWatchValue(value, vm.model.setting.labour_no) !== true) return;

                            vm.model.setting.labour_no = value;

                            if (utilityService.validateParmsValue(vm.model.setting.labour_no, true) !== true) return;

                            Promise.all([rememberFunc('labour_no'), retrieveSelectedJob()]).then(() => {
                                loadGrid();
                                loadGridOrders();
                                Promise.resolve();
                            });
                            break;
                        default:
                            utilityService.setValueToVariable(value);
                            break;
                    }
                };

                // #endregion FIELD CHANGE MULTI FUNCTIONS

                // #region FIELD DATE RANGE CHANGE FUNCTION

                vm.onDateRangeChanged = function (startDate, endDate, dateInterval) {
                    vm.model.setting.date_fom = startDate;
                    vm.model.setting.date_tom = endDate;
                    vm.model.setting.dateselector_index = +dateInterval <= 0 ? vm.model.setting.dateselector_index : dateInterval;

                    if (vm.model.setting.date_fom) rememberFunc('date_fom');
                    if (vm.model.setting.date_tom) rememberFunc('date_tom');
                    if (vm.model.setting.dateselector_index) rememberFunc('dateselector_index');

                    if (vm.model.setting.date_fom && vm.model.setting.date_tom && vm.model.setting.dateselector_index) {
                        //vm.model.setting.date_fomtom = vm.model.setting.date_fom + vm.model.setting.date_tom;
                        loadGrid();
                        loadGridOrders();
                    }
                };

                // #endregion FIELD DATE RANGE CHANGE FUNCTION

                // #region ON INIT FUNCTION

                vm.$onInit = function () {
                    translate();
                    loadSetting();
                    loadCompanies();
                };

                // #endregion ON INIT FUNCTION
            },
        ],
    });
})();
